module.exports = __webpack_public_path__ + "img/UnityUESceneLinkerRCAPI.735c8a8e.png";